import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { NotificationActions } from './notification.actions';

@Injectable({ providedIn: 'root' })
export class NotificationActionsFacade {
  private readonly _store = inject(Store);

  public refresh(): void {
    this._store.dispatch(NotificationActions.refresh());
  }

  public markAllViewed(): void {
    this._store.dispatch(NotificationActions.markAllViewed());
  }

  public markViewed(notificationId: string, viewed: boolean): void {
    this._store.dispatch(
      NotificationActions.markViewed({ notificationId, viewed }),
    );
  }
}
